import React from 'react';
import { Button } from 'react-bootstrap';

export const Event = ({ date, day, type, param1, comment, name, reason, account }) => (
    <tr>
        <div class="card mb-1" style={{ width: '14rem' }}>
            <div class="card-header">
                <strong>{name}</strong> ({account}) - <span class={"badge badge-pill badge-" + (() => { switch (reason) { case "VACATION": return "primary"; case "SICK": return "warning"; case "UNEXCUSED/OTHER": return "danger"; default: return "secondary"; }})()} >{reason}</span>
            </div>
            <div class="card-body">
                <p class="card-text">{comment}</p>
            </div>
        </div>
    </tr>
)


function checkDaySunday(day) { return day.weekday_nm === "Sunday" }
function checkDayMonday(day) { return day.weekday_nm === "Monday" }
function checkDayTuesday(day) { return day.weekday_nm === "Tuesday" }
function checkDayWednesday(day) { return day.weekday_nm === "Wednesday" }
function checkDayThursday(day) { return day.weekday_nm === "Thursday" }
function checkDayFriday(day) { return day.weekday_nm === "Friday" }
function checkDaySaturday(day) { return day.weekday_nm === "Saturday" }

function processDateData(d, dayOfWeek, returnFlag=0) {
    var wkday;
    if (typeof d === 'object') {
        switch (dayOfWeek) {
            case 'Sunday': wkday = d.find(checkDaySunday); break;
            case 'Monday': wkday = d.find(checkDayMonday); break;
            case 'Tuesday': wkday = d.find(checkDayTuesday); break;
            case 'Wednesday': wkday = d.find(checkDayWednesday); break;
            case 'Thursday': wkday = d.find(checkDayThursday); break;
            case 'Friday': wkday = d.find(checkDayFriday); break;
            case 'Saturday': wkday = d.find(checkDaySaturday); break;
        }   
        if (wkday !== undefined) {
            if (returnFlag === 1) {
                return wkday.status;
            }
            else if (returnFlag === 2) {
                return wkday.n[0].id;
            }
            return true;
        }
    }
    return false;
}

export const OpenAccount2 = ({ id, entrydate, account, name, startdate, enddate, comment, DateData, floaters, funcDelete, funcAddDriver, daily_cost }) => (
    <tr>

        <td class={"text-center table-secondary"} colspan="1"><div class="container"><a id={`${id}`} onClick={funcDelete} href="">{name} (${daily_cost}) ({comment})</a></div></td>

        {
            ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map((dayOfWeek) => (
                processDateData(DateData, dayOfWeek) ? <td class={"text-center table-" + (() => { switch (processDateData(DateData, dayOfWeek, 1)) { case "EMPTY": return "danger"; default: return "success"; } })()} colspan="1">
                    <select class="form-select" aria-label="Default select example" id={processDateData(DateData, dayOfWeek, 2)} onChange={funcAddDriver}>
                        <option selected>{processDateData(DateData, dayOfWeek, 1)}</option>
                    {
                        floaters.map((i) => (
                            <option value={i.id}>{i.name} (${i.daily_cost})</option>
                        ))
                    }
                </select>
            </td> : <td class={"text-center table-secondary"} colspan="1"></td>
        ))}
      
    </tr>
)


